exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-link-column[data-v-b494b45e] {\n  display: none;\n}\n", ""]);

// exports
